export default __webpack_public_path__ + "static/media/White Hand Warders.58ec4f60.jpg";